import { useEffect, useMemo, useState } from 'react'
import { Button, Stack, TableCell, TableRow } from '@mui/material'
import { Item } from './snippets'
import { Box, useTheme } from '@mui/system'
import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'
import { callAddFontRobotoBold } from './font/Roboto-bold'
import { callAddFontRobotoMedium } from './font/Roboto-Medium-normal'
import moment from 'moment'
import { focusElemnt, getLocalData, navigation3 } from './helper'
import { useAtom } from 'jotai'
import VirtualizedTable from './virtualisedTable'
import { divideInNIntegers, withPercentWidths, withPxWidths } from './mathHelper'
import { exportToCSV, exportToExcel } from './hook'
import { CargoRoleRightsAtom } from './jotaiState/commonStateAtoms'
import { getBaseGSTInvoiceURL, xlCol } from './constants'
import useToken from '../helpers/useTokens'
import { makeTable } from '../content/Reports/analysisReport/pdfAutotable'
import { lrDetailPdfFooter } from '../content/AcountingReport/common/AcountingConstants'
import { fixColSpan } from '../content/Reports/common/reportUtils'
import AppsIcon from '@mui/icons-material/Apps'
import ManageColumns from './ManageColumnsUI'
import { modalAtom } from './jotaiState/globalStateAtoms'
import SearchFilter from './SearchFilter'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
const currentDateTime = moment(window.getTime ? window.getTime() : new Date()).format('DD-MMM-YYYY HH:mm')


export const TableComponent = (props) => {
  const theme = useTheme()
  const [modal, setModal] = useAtom(modalAtom)
  const { tableHeaderColor } = theme
  const { reportName = '', hideControls = false } = props
  const { startID = '', endID = '' } = props
  const [cargoRoleRights] = useAtom(CargoRoleRightsAtom)
  const { Table1: RoleRightTable1 = [] } = cargoRoleRights
  const [roleRightsData] = RoleRightTable1
  const { AllowExportExcel = 1, AllowPrintandPdf = 1 } = { ...roleRightsData }
  const { loginData } = useToken()
  const [searchResult, setSearchResult] = useState(true)
  const { criteriaHeaders = [] } = props
  const { criteriaData = [] } = props
  const { mainHeader = [] } = props
  const { tableData = [] } = props
  const { excelTableData = [] } = props
  const { isMultiSplit = false } = props
  const { isInvoiceRedirect = false } = props
  const nonViewHeaders = mainHeader.filter((col) => col.ViewOnly !== true).map((a) => ({ ...a, field: a.field?.replace(/_view$/, '') }))
  const { isShowManageColumn = false, manageColumnID } = props
  const { hideHeader = false, isShowPdfPrint = true, colSpanMarker = '', isOpenPopupForSta = false, onLRClick = () => { }, totalSubKey = 0, serialNokey = '', isCSVRequired = false, fieldColor={} } = props
  const [manageColumn, setManageColumn] = useState([])
  const [columns, setColumns] = useState([])
  const [updatedTableData, setUpdatedTableData] = useState([])
  const [matches, setMatches] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [sortConfig, setSortConfig] = useState({
    field: null,
    direction: null,
  });
  const tables = [
    { id: 'mainTable', data: tableData, columnDefs: columns, totalColDef: [] },

  ];
  const visibleColumns = columns.length ? columns : mainHeader
  const headerLengths = divideInNIntegers(visibleColumns.length, totalSubKey)
  const pickedHeadersList = []
  let index = 0
  headerLengths.forEach((span) => {
    pickedHeadersList.push(visibleColumns[index].field)
    index += span
  })

  const setColumn = async () => {
    const savedColumns = await getLocalData(manageColumnID)
    let defaultColumns = []
    if (Array.isArray(savedColumns) && savedColumns.length > 0) {
      defaultColumns = savedColumns
    } else {
      defaultColumns = mainHeader
    }
    setManageColumn(defaultColumns)
    if (isShowManageColumn) {
      setColumns(defaultColumns.filter((col) => col.isSelected === true))
    } else {
      setColumns(mainHeader)
    }
  }
  const filteredData = useMemo(() => {
    if (!sortConfig.field || !sortConfig.direction) return updatedTableData;

    const { field, direction } = sortConfig;

    const isNumber = (v) => !isNaN(parseFloat(v)) && isFinite(v);

    const sortFn = (a, b) => {
      let valA = a[field];
      let valB = b[field];

      if (valA == null) valA = "";
      if (valB == null) valB = "";

      if (isNumber(valA) && isNumber(valB)) {
        valA = Number(valA);
        valB = Number(valB);
      } else {
        valA = String(valA).trim().toLowerCase();
        valB = String(valB).trim().toLowerCase();
      }

      if (valA < valB) return direction === "asc" ? -1 : 1;
      if (valA > valB) return direction === "asc" ? 1 : -1;
      return 0;
    };

    const result = [];
    let currentGroup = [];

    for (let i = 0; i < updatedTableData.length; i++) {
      const item = updatedTableData[i];

      if (item.dataType === 'subHeader' || item.dataType === 'header' || item.dataType === 'total') {
        // sort previous group before pushing new header
        if (currentGroup.length) {
          const sortData = (currentGroup.sort(sortFn)).map((obj, index) => ({ ...obj, [serialNokey]: index + 1 }))
          result.push(...sortData);
          currentGroup = [];
        }

        result.push(item); // keep header in place
      } else {
        currentGroup.push(item);
      }
    }

    // sort last group
    if (currentGroup.length) {
      const sortData = (currentGroup.sort(sortFn)).map((obj, index) => ({ ...obj, [serialNokey]: index + 1 }))
      result.push(...sortData);
    }

    return result;
  }, [updatedTableData, sortConfig]);

  useEffect(() => {
    const init = async () => {
      await setColumn()
    }
    init()
  }, [manageColumnID, mainHeader])
  useEffect(() => {
    if (!colSpanMarker || !columns.length) {
      setUpdatedTableData(tableData)
      return
    }

    const markerIndex = columns.findIndex(
      (col) => col.field === colSpanMarker
    )

    if (markerIndex === -1) {
      setUpdatedTableData(tableData)
      return
    }

    const updated = tableData.map((row) => {
      if (row.dataType === 'subHeader' && row.totalSubKey) {
        const subKeyValue = Object.keys(row)
          .filter(
            (key) =>
              !['dataType', 'align', 'colSpan', 'totalSubKey'].includes(key)
          )
          .map((key) => row[key] || '')

        const newObj = {}
        const colspanObj = {}
        const alignObj = {}

        pickedHeadersList.forEach((key, index) => {
          newObj[key] = subKeyValue[index] ?? ''
          colspanObj[key] = headerLengths[index]
          alignObj[key] =
            index === pickedHeadersList.length - 1
              ? 'right'
              : index === 0
                ? 'left'
                : 'center'
        })

        return {
          ...newObj,
          dataType: row.dataType,
          align: alignObj,
          colSpan: colspanObj,
          totalSubKey: row.totalSubKey,
        }
      }

      if (row?.dataType !== 'total' || !row?.colSpan) return row
      const firstField = Object.keys(row.colSpan)[0]
      const span = markerIndex + 1
      return {
        ...row,
        colSpan: {
          ...row.colSpan,
          [firstField]: span,
        },
      }
    })



    setUpdatedTableData(updated)
  }, [tableData, columns, colSpanMarker])

  const [criteriaHeaderExcel, criteriaDataExcel] = fixColSpan(criteriaHeaders, criteriaData, visibleColumns)
  const excelHeaders = visibleColumns.flatMap((col) => {
  if (typeof col.field === 'string' && col.field.includes('^^')) {
    if (isMultiSplit) {
      // Split into as many cols as ^^ segments
      const fields = col.field.split('^^')
      const headers = (col.exportHead || '').split('\n')
      return fields.map((field, i) => ({
        field,
        header: headers[i] || field,
        align: col.align,
      }))
    } else {
      // Original behavior — exactly 2
      const [field1, field2] = col.field.split('^^')
      const [header1, header2] = (col.exportHead || '').split('\n')
      return [
        { field: field1, header: header1, align: col.align },
        { field: field2, header: header2, align: col.align },
      ]
    }
  }
  return { ...col, field: col.field, header: col.exportHead?.replace(/\n/g, ' '), align: col.align }
})
  const span1 = divideInNIntegers(excelHeaders.length, 2)

  const header1 = [
    [
      { header: `Report For: ${reportName}`, field: '', span: span1[0], mainHeader: true },
      { header: `Company Name : ${loginData.strCompanyName}`, field: '', span: span1[1] },
    ],
  ]
  const excelHeaderList = [header1, criteriaHeaderExcel, excelHeaders]
  const excelDataList = [[], criteriaDataExcel]
  excelDataList.push(excelTableData.length ? excelTableData : updatedTableData)

  const printClick = (isSave) => {
    jsPDF.API.events.push(['addFonts', callAddFontRobotoBold])
    jsPDF.API.events.push(['addFonts', callAddFontRobotoMedium])
    const HeaderColumns = criteriaHeaders.map((col) => {
      return { header: col.header, dataKey: col.field, xlCol: col.xlCol || xlCol }
    })
    const pdfFontSize = 1
    const orientation = visibleColumns.length > 14 ? 'l' : 'p'
    const format = orientation === 'l' ? [1810, 1280] : [1280, 1810]
    const pdfColumns = withPxWidths(visibleColumns, format[0] - 60).map((col) => {
      return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol, width: col.width || 0 }
    })
    const doc = new jsPDF({ orientation: orientation, format: format, unit: 'px', compress: true })
    var totalPagesExp = '{total_pages_count_string}'
    doc.setProperties({
      title: `${reportName}.pdf`,
      subject: `${reportName}`,
      author: 'Maven Tech Labs Pvt. Ltd.',
      keywords: 'maven tech, Cargo system, Receive',
      creator: 'MTLPL',
    })
    const customFunction = (data, doc) => {
      doc.setTextColor(40)
      doc.addImage('/images/logo-66.png', 'JPEG', 30, 50, 50, 50)
      doc.setFontSize(26).setFont('Roboto', 'bold')
      doc.setTextColor(16, 79, 162)
      doc.text(`Cargo System | ${reportName}`, 30 + 60, 80)
      doc.setTextColor(0, 0, 0)
      doc.setFontSize(22).setFont('Roboto', 'bold')
      doc.text(`Company Name :${loginData.strCompanyName}`, doc.internal.pageSize.width - data.settings.margin.left, 80, 'right')
    }
    const customFunction2 = (data, doc) => {
      lrDetailPdfFooter(data, loginData, totalPagesExp)
    }
    makeTable(doc, autoTable, HeaderColumns, criteriaData, pdfFontSize, reportName, loginData, 'everyPage', customFunction, 120, false)
    makeTable(doc, autoTable, pdfColumns, updatedTableData, pdfFontSize, reportName, loginData, hideHeader ? 'never' : 'everyPage', customFunction2)

    doc.setFont('Roboto')
    if (typeof doc.putTotalPages === 'function') {
      doc.putTotalPages(totalPagesExp)
    }
    if (isSave) {
      doc.save(`${reportName} ${currentDateTime}.pdf`)
    } else {
    }
    setTimeout(() => {
      const pdfUrl = doc.output('bloburl')
      document.getElementById('anaLRDetailsOutput').data = pdfUrl
      // document.getElementById('anaLRDetailsOutput').data = doc.output('datauristring', `${reportName}.pdf`)
      focusElemnt('backBtn')
    }, 2000)
  }
  const handleSortClick = (field) => () => {
    setSortConfig((prev) => {
      if (prev.field === field) {
        const newDirection = prev.direction === "asc" ? "desc" : "asc";
        return { field: field, direction: newDirection };
      } else {
        return { field: field, direction: "asc" };
      }
    });
  }
  const headerContent = () => {
    let viewHeader = withPercentWidths(columns)
    return (
      <>
        <TableRow>
          {viewHeader.map((item) => {
            return (
              <TableCell
                onClick={item.isSortIcon && handleSortClick(item.field)}
                style={{
                  backgroundColor: tableHeaderColor?.isHeadingColor,
                  color: '#444',
                  fontSize: '12px',
                  lineHeight: '16px',
                  // letterSpacing: '0.24px',
                  fontWeight: '700',
                  whiteSpace: 'pre-line',
                  padding: '6px 4px',
                  width: item.width,
                  textAlign: item.align || 'left',
                  borderRight: item.headerSx?.borderRight || 'none',
                  verticalAlign: 'middle',
                  cursor: item.isSortIcon ? "pointer" : "default",
                }}
                colSpan={1}
              >
                {item.isSortIcon ?
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: item.align === 'right' ? 'end' : 'start' }}>
                    {item?.header}
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        lineHeight: 0,
                      }}
                    >
                      <ArrowDropUpIcon style={{ marginBottom: '-6px', color: sortConfig.field === item.field && sortConfig.direction === 'asc' ? '#fff' : '#444', width: 'auto !important' }} />
                      <ArrowDropDownIcon style={{ marginTop: '-6px', color: sortConfig.field === item.field && sortConfig.direction === 'desc' ? '#fff' : '#444', width: 'auto !important' }} />
                    </div>
                  </Box>
                  : item?.header
                }
              </TableCell>
            )
          })}
        </TableRow>
      </>
    )
  }
  const getFieldColor = (field, dataType) => {
  if (fieldColor?.[field] && dataType!=='subHeader' && dataType!=='header') {
    return fieldColor[field]
  }else{
    return '#444'
  }
}
  const DisPatchBody = ({ row, index, tableHeaderColor, columnDefs, matches, currentMatch }) => {
    if (!row?.dataType) return null
    const getStyles = (field, align, rowData) => {
      const common = {
        minHeight: '36px',
        fontSize: '12px',
        padding: '6px 4px',
        fontFamily: 'Roboto',
        color:getFieldColor(field, row?.dataType)
      }
      if (row.dataType === 'header') {
        return {
          ...common,
          fontWeight: '700',
          backgroundColor: row?.backgroundColor ?? tableHeaderColor?.isHeadingColor,
          textAlign: align,
          whiteSpace: 'pre-line',
        }
      }
      if (row.dataType === 'entry') {
        return {
          ...common,
          fontWeight: '500',
          textAlign: align || 'left',
          height: '36px',
          whiteSpace: 'pre-line',
          borderRight: rowData?.borderRight || 'none',
        }
      }
      if (row.dataType === 'subHeader') {
        return {
          ...common,
          fontWeight: '600',
          backgroundColor: row?.backgroundColor ?? tableHeaderColor?.isSubHeadingColor,
          textAlign: row.align?.[field] || 'left',
          position: 'sticky',
          borderRight: rowData?.borderRight || 'none',
        }
      }
      if (row.dataType === 'total') {
        return {
          ...common,
          color:row.colour||getFieldColor(field, row?.dataType)||undefined,
          fontWeight: '600',
          backgroundColor: tableHeaderColor?.isTotalColor,
          textAlign: row.align?.[field] || 'right',
          borderRight: rowData?.borderRight || 'none',
        }
      }
    }
    return (
      <>
        {(() => {
          let skip = 0

          return columnDefs.map((item, i) => {
            if (skip > 0) {
              skip--
              return null
            }
            let colSpan = row.colSpan?.[item.field] || 1



            skip = colSpan - 1
            const key = `${index}-${item.field}`
            const isMatched = matches?.has(key)
            const isActive =
              currentMatch &&
              currentMatch.rowIndex === index &&
              currentMatch.field === item.field

            let checkSort = row.dataType === 'header' && item.isSortIcon && row.disableSortIcon !== true
            return (
              <TableCell
                onClick={checkSort && handleSortClick(item.field)}
                data-field={item.field}   // 👈 ADD THIS LINE
                className="reportTD"
                key={item.field + i + index}
                colSpan={colSpan}
                style={{
                  ...getStyles(item.field, item.align, item.headerSx),
                  ...(item.width
                    ? {
                      minWidth: item.width,
                      width: item.width,
                      whiteSpace: 'pre-line',
                      wordBreak: 'break-word'
                    }
                    : {
                      whiteSpace: 'pre-line',
                    }),
                  cursor: checkSort ? "pointer" : "default",

                }}
              //style={getStyles(item.field, item.align)}
              >
                <span
                  style={{
                    backgroundColor: isActive ? 'orange' : isMatched ? 'yellow' : 'transparent', color: isOpenPopupForSta && item.field === 'LRNO' ? 'blue' : 'inherit',
                    textDecoration: isOpenPopupForSta && item.field === 'LRNO' ? 'underline' : 'none',   // 👈 ADD THIS
                    cursor: isOpenPopupForSta && item.field === 'LRNO' ? 'pointer' : 'default'
                  }}
                  onClick={() => {
                    if (isOpenPopupForSta && item.field === 'LRNO' && onLRClick) {
                      onLRClick(row)
                    }
                  }}
                >
                  {isInvoiceRedirect &&
                    (item.field === "BookingGSTInvoiceNo" || item.field === "DeliveryGSTInvoiceNo" || item.field === "BookingGSTInv" || item.field === "DelGSTInv") ? (
                    (() => {

                      // GST report
                      if (item.field === "BookingGSTInv" || item.field === "DelGSTInv") {
                        const url =
                          item.field === "BookingGSTInv"
                            ? row?.BoookingGSTLink
                            : row?.DeliveryGSTLink;

                        return row[item.field] ? (
                          <a
                            href={url}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: "blue", textDecoration: "underline" }}
                          >
                            {row[item.field]}
                          </a>
                        ) : (
                          row[item.field]
                        );
                      }
                      let url = ''
                      let isVisible = false
                      if (item.field === "BookingGSTInvoiceNo") {
                        isVisible = row.IsBookingInvoice
                        url = getBaseGSTInvoiceURL(row?.BookingID, 'B', loginData?.intCompanyID)
                      }
                      if (item.field === "DeliveryGSTInvoiceNo") {
                        isVisible = row.IsDeliveryInvoice
                        url = getBaseGSTInvoiceURL(row?.BookingID, 'D', loginData?.intCompanyID)
                      }

                      return isVisible && row[item.field] ? (
                        <a
                          href={url}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ color: 'blue', textDecoration: 'underline' }}
                        >
                          {row[item.field]}
                        </a>
                      ) : (
                        row[item.field]
                      )
                    })()
                  )
                    : (

                   <>
                      {checkSort ?
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: item.align === 'right' ? 'end' : 'start' }}>
                          {row[item.field]}
                          {checkSort &&
                            (
                              <div
                                style={{
                                  display: 'flex',
                                  flexDirection: 'column',
                                  alignItems: 'center',
                                  lineHeight: 0,
                                }}
                              >
                                <ArrowDropUpIcon style={{ marginBottom: '-6px', color: sortConfig.field === item.field && sortConfig.direction === 'asc' ? '#fff' : '#444', width: 'auto !important' }} />
                                <ArrowDropDownIcon style={{ marginTop: '-6px', color: sortConfig.field === item.field && sortConfig.direction === 'desc' ? '#fff' : '#444', width: 'auto !important' }} />
                              </div>
                            )
                          }
                        </Box>
                        : row[item.field]}
                    </>
                  )}
                </span>
              </TableCell>
            )
          })
        })()}
      </>
    )
  }
  const bodyContent = (index, obj, extra) => {
    return <DisPatchBody row={obj} index={index} tableHeaderColor={tableHeaderColor} columnDefs={columns} matches={extra.matchSet} currentMatch={extra.currentMatch} />
  }
  const onSaveColumns = (items) => {
    setManageColumn(items)
    setColumns(items.filter((col) => col.isSelected === true))
    localStorage.setItem(manageColumnID, JSON.stringify(items))
  }
  return (
    <>
      <SearchFilter
        tables={tables}
        matches={matches}
        setMatches={setMatches}
        currentIndex={currentIndex}
        setCurrentIndex={setCurrentIndex}
      />
      <Stack style={{ margin: '10px' }}>
        <Item className="userReport" style={{ padding: 0, display: hideControls ? 'none' : 'flex' }}>
          <Item className="userReport-heading" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '10px' }}>
            Report For: {reportName}
            {isShowManageColumn && (
              <Box
                style={{ height: '32px', display: 'flex', padding: '8px 12px', justifycontent: 'center', alignitems: 'center', gap: '6px' }}
                id="dispatchReportManageColumn"
                tabIndex={0}
                onClick={() => setModal('ShowManageColumn')}
              >
                <span tabIndex={0} style={{ display: 'flex', margin: '-3px' }}>
                  <AppsIcon />
                </span>
                <span tabIndex={0} style={{ fontWeight: 'bold' }}>
                  MANAGE COLUMNS
                </span>
              </Box>
            )}
          </Item>
          <Item className="userReport-buttons" style={{ paddingRight: 0 }}>
            {searchResult ? (
              <>
                <Box>
                  <Button
                    id="analsExpToExlbtn"
                    variant="outlined"
                    className="userWisereporttembtn"
                    disabled={!AllowExportExcel}
                    onClick={() =>
                      exportToExcel({
                        fileName: `${reportName} ${currentDateTime}.xlsx`,
                        sheetName: reportName,
                        headersList: excelHeaderList,
                        dataList: excelDataList,
                      })
                    }
                  >
                    Export to Excel
                  </Button>
                </Box>
                {isCSVRequired && <Box>
                  <Button
                    id="analsExpToCsvBtn"
                    variant="outlined"
                    className="userWisereporttembtn"
                    disabled={!AllowExportExcel}
                    onClick={() =>
                      exportToCSV({
                        fileName: `${reportName} ${currentDateTime}.csv`,
                        headersList: [excelHeaders],
                        dataList: [excelTableData.length ? excelTableData : updatedTableData],
                      })
                    }
                  >
                    Export as CSV
                  </Button>
                </Box>}
                {
                  isShowPdfPrint && <>
                    <Box>
                      <Button
                        variant="outlined"
                        className="userWisereporttembtn"
                        onClick={() => {
                          setSearchResult(false)
                          printClick(true)
                        }}
                        disabled={!AllowPrintandPdf}
                        onKeyDown={(e) =>
                          navigation3(e, 'analPrintBtn', !AllowPrintandPdf ? startID : 'analsExpToExlbtn', () => {
                            setSearchResult(false)
                            printClick(true)
                          })
                        }
                        id="anaxportAsPdfBtn"
                      >
                        Export to Pdf
                      </Button>
                    </Box>
                    <Box>
                      <Button
                        variant="outlined"
                        className="userWisereporttembtn"
                        onClick={() => {
                          setSearchResult(false)
                          printClick(false)
                        }}
                        disabled={!AllowPrintandPdf}
                        id="analPrintBtn"
                        onKeyDown={(e) =>
                          navigation3(e, endID, 'anaxportAsPdfBtn', () => {
                            setSearchResult(false)
                            printClick(false)
                          })
                        }
                      >
                        Print
                      </Button>
                    </Box>
                  </>
                }
              </>
            ) : (
              <>
                <Box>
                  <Button
                    id="backBtn"
                    variant="outlined"
                    className="userWisereporttembtn"
                    onClick={() => {
                      setSearchResult(true)
                    }}
                    onKeyDown={(e) =>
                      navigation3(e, startID, endID, () => {
                        setSearchResult(true)
                        focusElemnt(endID)
                      })
                    }
                  >
                    Back
                  </Button>
                </Box>
              </>
            )}
          </Item>
        </Item>
      </Stack>
      <Stack style={{ margin: '0px 10px 20px 10px' }}>
        {searchResult ? (
          <VirtualizedTable
            id="mainTable"
            tableData={filteredData}
            headerContent={hideHeader ? false : headerContent}
            rowContent={bodyContent}
            tableStyle={{ tableLayout: 'auto', width: '100%' }}
            autoResize={true}
            matches={matches}
            currentIndex={currentIndex}
            isWindowScroll={true}
          />
        ) : (
          <object
            id="anaLRDetailsOutput"
            type="application/pdf"
            width={'100%'}
            height={`${window.innerHeight - 100}px`}
            title={`MTLPL -Cargo System -${reportName}`}
            aria-label={`MTLPL -Cargo System -${reportName}`}
          ></object>
        )}
      </Stack>
      {modal === 'ShowManageColumn' && <ManageColumns headers={manageColumn} onSave={onSaveColumns} updateModal={setModal} />}
    </>
  )
}
